const DEFAULT_NAMESPACE = "";
const DEFAULT_EXCLUDE_FROM_NAMESPACE = ["from", "to", "timezone"];
class UniqueUrlKeyMapper {
  constructor(options) {
    this.index = /* @__PURE__ */ new Map();
    this.options = {
      namespace: (options == null ? void 0 : options.namespace) || DEFAULT_NAMESPACE,
      excludeFromNamespace: (options == null ? void 0 : options.excludeFromNamespace) || DEFAULT_EXCLUDE_FROM_NAMESPACE
    };
  }
  getOptions() {
    return this.options;
  }
  getNamespacedKey(keyWithoutNamespace) {
    if (this.options.namespace && !this.options.excludeFromNamespace.includes(keyWithoutNamespace)) {
      return `${this.options.namespace}-${keyWithoutNamespace}`;
    }
    return keyWithoutNamespace;
  }
  getUniqueKey(keyWithoutNamespace, obj) {
    const key = this.getNamespacedKey(keyWithoutNamespace);
    const root = obj.getRoot();
    let objectsWithKey = this.index.get(key);
    if (isVariableKey(keyWithoutNamespace)) {
      if (!objectsWithKey || objectsWithKey.findIndex((o) => o === obj) === -1) {
        objectsWithKey = this.buildDeterministicVariableIndex(keyWithoutNamespace, key, root);
      }
    }
    if (!objectsWithKey) {
      this.index.set(key, [obj]);
      return key;
    }
    let address = objectsWithKey.findIndex((o) => o === obj);
    if (address === -1) {
      filterOutOrphanedObjects(objectsWithKey);
      objectsWithKey.push(obj);
      address = objectsWithKey.length - 1;
    }
    if (address > 0) {
      return `${key}-${address + 1}`;
    }
    return key;
  }
  clear() {
    this.index.clear();
  }
  buildDeterministicVariableIndex(keyWithoutNamespace, namespacedKey, root) {
    const matchingObjectsWithPath = collectObjectsWithPathForKey(root, keyWithoutNamespace);
    matchingObjectsWithPath.sort(compareByDepthThenPath);
    const matchingObjects = matchingObjectsWithPath.map((obj) => obj.sceneObject);
    this.index.set(namespacedKey, matchingObjects);
    return matchingObjects;
  }
}
function isVariableKey(keyWithoutNamespace) {
  return keyWithoutNamespace.startsWith("var-");
}
function compareByDepthThenPath(a, b) {
  if (a.path.length !== b.path.length) {
    return a.path.length - b.path.length;
  }
  return comparePathSegments(a.path, b.path);
}
function comparePathSegments(aPath, bPath) {
  const minLength = Math.min(aPath.length, bPath.length);
  for (let i = 0; i < minLength; i++) {
    if (aPath[i] !== bPath[i]) {
      return aPath[i] - bPath[i];
    }
  }
  return aPath.length - bPath.length;
}
function collectObjectsWithPathForKey(root, keyWithoutNamespace) {
  const result = [];
  const visit = (obj, path) => {
    var _a;
    if ((_a = obj.urlSync) == null ? void 0 : _a.getKeys().includes(keyWithoutNamespace)) {
      result.push({ sceneObject: obj, path: [...path] });
    }
    let childIndex = 0;
    obj.forEachChild((child) => {
      visit(child, [...path, childIndex]);
      childIndex++;
    });
  };
  visit(root, []);
  return result;
}
function filterOutOrphanedObjects(sceneObjects, root) {
  for (let i = 0; i < sceneObjects.length; i++) {
    const obj = sceneObjects[i];
    if (isOrphan(obj)) {
      sceneObjects.splice(i, 1);
      i--;
    }
  }
}
function isOrphan(obj, root) {
  if (!obj.parent) {
    return false;
  }
  let found = false;
  obj.parent.forEachChild((child) => {
    if (child === obj) {
      found = true;
      return false;
    }
    return;
  });
  if (!found) {
    return true;
  }
  return isOrphan(obj.parent);
}

export { UniqueUrlKeyMapper };
//# sourceMappingURL=UniqueUrlKeyMapper.js.map
